import { ELLA } from '../types';
export default {
  type: ELLA,
  service: 'Ellaism',
  url: 'https://jsonrpc.ellaism.org',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
